import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

interface OnboardingLayoutProps {
  children: ReactNode;
  progress: number;
  onBack?: () => void;
  showBackButton?: boolean;
}

const OnboardingLayout = ({
  children,
  progress,
  onBack,
  showBackButton = true
}: OnboardingLayoutProps) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <div
      className="min-h-screen bg-[#ffffeb] flex flex-col"
      style={{
        backgroundImage: `
          repeating-linear-gradient(0deg, transparent, transparent 7px, rgba(7, 127, 93, 0.03) 7px, rgba(7, 127, 93, 0.03) 8px),
          repeating-linear-gradient(90deg, transparent, transparent 7px, rgba(7, 127, 93, 0.03) 7px, rgba(7, 127, 93, 0.03) 8px)
        `
      }}
    >
      {/* Sticky header with progress bar and back button */}
      <div className="sticky top-0 z-50 bg-[#3cbe8c] border-b-4 border-[#077f5d]">
        <div className="flex items-center px-4 py-3 gap-4">
          {/* Back button - Pixel Style */}
          {showBackButton && (
            <button
              type="button"
              onClick={handleBack}
              className="bg-white border-3 border-[#077f5d] p-2"
              style={{ boxShadow: '3px 3px 0 #077f5d' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '2px 2px 0 #077f5d';
                e.currentTarget.style.transform = 'translate(-1px, -1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '3px 3px 0 #077f5d';
                e.currentTarget.style.transform = 'translate(0, 0)';
              }}
            >
              <ChevronLeft className="w-5 h-5 text-[#077f5d]" strokeWidth={3} />
            </button>
          )}

          {/* Progress bar - Pixel Style */}
          <div className="flex-1">
            <div
              className="w-full bg-white border-2 border-[#077f5d] h-4"
              style={{ overflow: 'hidden' }}
            >
              <div
                className="h-full bg-[#077f5d]"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center px-4 py-4">
        <div className="w-full max-w-md">
          {children}
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout;
